import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient, getLoggedinUser } from 'helpers/api_helper';
import { RootState } from '../app/store/store';

interface DashboardStats {
    totalOrder: number;
    revenue: number;
    totalCustomer: number;
    totalCollection: number;
    totalInventory: number;
    totalInward: number;
    diamondInward: number;
    goldInward: number;
    memoDiamondInward: number;
    memoGoldInward: number;
}

const initialState: DashboardStats = {
    totalOrder: 0,
    revenue: 0,
    totalCustomer: 0,
    totalCollection: 0,
    totalInventory: 0,
    totalInward: 0,
    diamondInward: 0,
    goldInward: 0,
    memoDiamondInward: 0,
    memoGoldInward: 0,
};

export const fetchDashboardStats = createAsyncThunk(
    'dashboard/fetchStats',
    async (_, { rejectWithValue }) => {
        try {
            const user = getLoggedinUser();
            if (!user) {
                return null;
            }
            const response = await apiClient.get('/api/v1/Dashboard/GetDashboardCountDetails');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch dashboard stats');
        }
    }
);

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchDashboardStats.fulfilled, (state, action) => {
            return { ...state, ...action.payload };
        });
    },
});

export default dashboardSlice.reducer;

export const selectDashboardStats = (state: RootState) => state.dashboard;
